import { render, staticRenderFns } from "./EMobilityPage.vue?vue&type=template&id=89fa89b4&scoped=true"
import script from "./EMobilityPage.vue?vue&type=script&lang=js"
export * from "./EMobilityPage.vue?vue&type=script&lang=js"
import style0 from "./EMobilityPage.vue?vue&type=style&index=0&id=89fa89b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fa89b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
